<template>
  <div class="dropdown-container">
    <div class="form-group">
      <input-field
        :label="labelName"
        label-position="top"
        :info="info"
        @openInfo="showInfo(info.title, info.message)"
      >
        <div class="d-flex align-items-center w-100">
          <input
            v-if="showProtocol"
            v-model="protocol"
            type="text"
            :disabled="true"
            class="form-control protocol-input"
            :class="isSsl && 'ssl-input'"
          >
          <input
            v-model="newTag"
            type="text"
            class="form-control pr-5"
            :class="showProtocol && 'cname-input'"
            :placeholder="placeholder"
            @keyup.enter="addTag"
          >
          <b-button
            v-if="showAddBtn"
            variant="outline-none"
            class="text-primary gap-3 position-absolute"
            style="right:60px; z-index: 10;"
            @click="addTag"
          >
            <GjIcon
              :name="buttonIconName"
              size="18"
            />
            Add
          </b-button>
        </div>
      </input-field>
    </div>
    <ul
      v-if="tags.length !== 0"
      class="list-group"
      :class="{'active': getMaxHeight() === 250}"
    >
      <li
        v-for="(tag, index) in tags"
        :key="index"
        class="d-flex align-items-center ml-1"
      >
        <span
          v-if="showProtocol"
          class="noSsl-input"
          :class="isSsl && 'ssl-input'"
        >
          {{ isSsl ? 'https://' : 'http://' }}
        </span>
        {{ removeProtocol(tag) }}
        <div
          v-if="showSingleItem"
          class="cursor-pointer"
          @click="removeTag(tag)"
        >
          <GjIcon
            :name="iconName"
            size="18"
          />
        </div>
        <div class="cursor-pointer custom-margin ml-1">
          <b-dropdown
            v-if="!showSingleItem"
            id="dropdown-1"
            no-caret
            variant="none"
            class="custom-dropdown "
          >
            <template #button-content>
              <GjIcon
                :name="iconName"
                size="18"
              />
            </template>
            <b-dropdown-item
              v-for="item in options"
              :key="item.id"
              class="d-flex align-items-center pr-0 pl-0 w-full"
              @click="item.name === 'Delete' ? removeTag(tag) : $emit('clicked-option', item, tag)"
            >
              <GjIcon
                :name="item.iconName"
                size="18"
              />
              {{ item.name }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </li>
    </ul>
    <info
      v-if="openInfo"
      :title="infoTitle"
      :message="infoMessage"
      @close="openInfo = false"
    />
  </div>

</template>
<script>
export default {
  props: {
    labelName: {
      type: String,
      default: '',
      required: true,
    },
    iconName: {
      type: String,
      default: 'Close',
    },
    buttonIconName: {
      type: String,
      default: 'Plus',
    },
    placeholder: {
      type: String,
      default: '',
    },
    showAddBtn: {
      type: Boolean,
      default: true,
    },
    tags: {
      type: Array,
      default: () => ({}),
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    showSingleItem: {
      type: Boolean,
      default: false,
    },
    showProtocol: {
      type: Boolean,
      default: false,
    },
    isSsl: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => ([]),
    },

  },
  data() {
    return {
      newTag: '',
      openInfo: false,
      protocols: ['http://', 'https://'],
    }
  },
  computed: {
    protocol() {
      return this.isSsl ? this.protocols[1] : this.protocols[0]
    },
  },
  methods: {
    addTag() {
      this.newTag = this.newTag.trim()
      if (this.protocols.some(protocol => this.newTag.startsWith(protocol))) {
        this.newTag = this.removeProtocol(this.newTag)
      }
      if (this.newTag !== '' && !this.tags.includes(this.newTag)) {
        this.tags.push(this.newTag)
        this.newTag = ''
      }
      this.$emit('tags', this.tags)
    },
    removeProtocol(cname) {
      return cname.trim().replace(/^https?:\/\//, '')
    },
    removeTag(element) {
      this.$emit('deletedTags', this.tags.filter(el => el !== element))
    },
    showInfo(title, info) {
      this.openInfo = true
      this.infoTitle = title
      this.infoMessage = info
    },
    getMaxHeight() {
      const element = document.querySelector('.list-group')
      if (element) {
        const maxHeight = element.getBoundingClientRect().height
        return maxHeight
      }
      return 0
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-dropdown {
  ::v-deep {
    .btn {
      padding: 0 !important;
    }

    .dropdown-item{
      width: 100%;
    }

    .dropdown-item.active > small {
      font-weight: bolder;
    }

    .dropdown-menu {
      height: auto;
      overflow-y: auto;
      max-height: 250px;
      margin-top: 6px;
      min-width: 132px;
    }
  }
}

.form-control {
  padding-right: 80px;
}
.ssl-input{
  color: #36b37e !important;
  font-weight: 500;
}
.noSsl-input{
  color: gray;
  font-weight: 500;
}
.protocol-input{
  max-width: 65px;
  padding-right: 0px;
  border-right: none;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  color: gray;
  background-color: #ffffff !important;
  font-weight: 500;
}
.cname-input{
  padding-left: 0px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left: none;
}
.list-group {
  max-height: 250px;
  margin-bottom: 15px;

  &.active {
    overflow-y: auto;
  }
}

.gap-3{
  gap: 3px;
}

</style>
